"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var search = window.location.search;

function _default(route) {
  return "" + route + search;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hubspot-plugin-common/static-1.186/js/buildWordpressUrl.js
// module id = 370
// module chunks = 5 6 7